export const TERMINAL_CONNECTION_ERROR_TEXT =
  "Unfortunately, we can't connect you, and your provider may be unable to admit you. Please try refreshing. If the issue persists, please contact support via the client portal.";
export const RETRYING_CONNECTION_INFO_TEXT =
  "We’re working on connecting you. If the issue persists, please contact support via the client portal.";
